import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  border: `0.1rem solid ${theme.colors.base05}`,

  borderRadius: '0.8rem',

  color: theme.colors.base01,
  backgroundColor: 'transparent',
}));

export const ContentContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  padding: '1.2rem 1rem',
});

export const ContentLeftContainer = styled('div')({
  display: 'flex',
  justifyContent: 'left',
  alignItems: 'center',

  columnGap: '0.6rem',
});

export const ContentLeftTextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  color: theme.colors.base01,
}));
